import { useSelector } from "react-redux";
import NotFound from "./NotFound";
import { Outlet } from "react-router-dom";

const Private = () => {
    const userDetails = useSelector((state) => state.user.details);
    return userDetails? <Outlet /> : <NotFound />
}

export default Private